module.exports = __webpack_public_path__ + "img/cal-sterilization.157d4472.png";